export default __webpack_public_path__ + "static/media/forgot_password_1.b2ae8a52.svg";